import { Heading, HeadingSize, Paragraph } from 'components/Ui-Kits/Text'
import { auctionStatuses } from 'constants/publishedProduct'
import dayjs from 'dayjs'
import { useAuction } from 'hooks/data/auction/useAuction'
import { useAuctionProducts } from 'hooks/data/auction/useAuctionProducts'
import { useAppTranslation } from 'i18n/hooks'
import { useMemo } from 'react'
import { Redirect, useParams } from 'react-router'
import styled from 'styled-components'
import { CurrentItem } from './CurrentItem'
import { ItemsList } from './ItemsList'

export const LiveAuction = () => {
  const { auctionId } = useParams()
  const { auction, loading } = useAuction(auctionId)
  const { products } = useAuctionProducts(auctionId)
  const product = useMemo(
    () =>
      products.find(({ auctionStatus }) => auctionStatus === auctionStatuses.CURRENT) ||
      [...products]
        .sort(({ sort: a }, { sort: b }) => b - a)
        .find(({ auctionStatus }) => auctionStatus !== auctionStatuses.WAITING) ||
      products[0],
    [products]
  )
  const { t } = useAppTranslation()

  if (!auction && !loading) return <Redirect to="/not-found" />
  if (!auction || !product) return null

  return (
    <Container>
      <CurrentItem product={product} auction={auction} total={products.length} />
      <ItemsList products={products} activeProductId={product?.id} />
      {!!auction.pauseMessage && (
        <PausedMessage>
          <Heading color="primary" bold size={HeadingSize.SMALL}>
            {auction.pauseMessage}
          </Heading>
        </PausedMessage>
      )}
      {!!auction?.liveAuctionEndedAt && (
        <PausedMessage>
          {t('liveAuctionHasEndedAt', { date: dayjs(auction.liveAuctionEndedAt).format('DD-MM-YYYY HH:mm') }).map(
            (text, index) => (
              <Paragraph color="primary" key={index} bold mt={0} mb={0}>
                {text.replace('{{ date }}', dayjs(auction.liveAuctionEndedAt).format('DD-MM-YYYY HH:mm'))}
              </Paragraph>
            )
          )}
        </PausedMessage>
      )}
    </Container>
  )
}

const Container = styled.div`
  flex-wrap: wrap;
  max-width: 1220px;
  width: 100%;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 760px) {
    flex-direction: row;
  }
  justify-content: space-between;
  margin: 2rem auto;
  position: relative;
`
const PausedMessage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.9);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`
